import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Contact from 'views/contact';
import Layout from 'components/layout';
import { NavBar, PopupRedirect } from 'components';
import { pages } from 'config/pages';
import config from '../../meta/config';

class ContactPage extends Component {
  render() {
    const page = pages.contact;
    const { navColors } = page;
    const canonical = `${config.siteUrl}/contact/`;

    return (
      <Layout {...{page, canonical}}>
        <Helmet title="Contact">
          <meta
            name={'description'}
            content={
              'Adapting to digital economy is critical for companies around the world. However the shift from traditional business model means more than just releasing a new website, mobile app or e-commerce platform.'
            }
          />
          <link rel="canonical" href={canonical} />
        </Helmet>
        <NavBar color={navColors} />
        <PopupRedirect message={'contact'} />
        <Contact />
      </Layout>
    );
  }
}

export default ContactPage;
